import Vue from 'vue';
import { Toast, Swipe, SwipeItem, Popup, Search } from 'vant';

Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Search);
